import { render } from "./HarvesterVFAddress.vue?vue&type=template&id=5d4937aa&scoped=true"
import script from "./HarvesterVFAddress.vue?vue&type=script&lang=js"
export * from "./HarvesterVFAddress.vue?vue&type=script&lang=js"

import "./HarvesterVFAddress.vue?vue&type=style&index=0&id=5d4937aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4937aa"]])

export default __exports__